import React from "react";
import { Outlet } from "react-router-dom";
import AdminRouteLayout from "../../navigation/AdminRouteLayout";

const HelpCenterRoot = () => {
  return (
    <AdminRouteLayout>
      <Outlet />
    </AdminRouteLayout>
  );
};

export default HelpCenterRoot;
